import Requester from "./Requester";

export interface User {
    id: number
    name: string
}

interface CreateDTO {
    vendorId: string
    email: string
    name: string
    password: string
}

export function getUsers() {
    const requester = new Requester();

    return requester.get(requester.getUrl("api/users"))
}

export function destroy(id) {
    // const requester = new Requester();

    // return requester.delete(requester.getUrl(`api/projects/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/users`), values)
}

export function update(id, data) {
    // const requester = new Requester();

    // return requester.put(requester.getUrl(`api/projects/${id}`), {

    // })
}

export default {
    getUsers,
    create,
    destroy,
    update
}